let userAgent = '';

export const init = (configUserAgent) => {
    if (!configUserAgent) {
        throw new Error('iqos-mw error: userAgent is required');
    }
    userAgent = configUserAgent;
};

export const getUserAgent = () => userAgent;
